// src/components/organisms/TournamentPickerModal.tsx
import * as React from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Box, TextField, Autocomplete, ToggleButtonGroup, ToggleButton,
    CircularProgress, Alert, Stack, Avatar, Typography
} from "@mui/material";
import { useNavigate } from "react-router-dom";
interface Tournament {
    name: string;
    slug: string;
    authorId?: number;
}

interface Props {
    open: boolean;
    onClose: () => void;
    getToken: () => string;
    myTournaments: any;
}

export default function TournamentPickerModal({ open, onClose, myTournaments }: Props) {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState<string | null>(null);
    const [options, setOptions] = React.useState<Tournament[]>([]);
    const [selected, setSelected] = React.useState<Tournament | null>(null);
    const [inputValue, setInputValue] = React.useState("");

    const fetchTournaments = React.useCallback(async () => {
        setLoading(true);
        setError(null);
        const list: Tournament[] = Array.isArray(myTournaments) ? myTournaments : [];
        setOptions(list);
        setLoading(false);
    }, [myTournaments]);

    React.useEffect(() => {
        if (open) {
            setSelected(null);
            setInputValue("");
            fetchTournaments();
        }
    }, [open, fetchTournaments]);

    const handleConfirm = () => {
        if (!selected?.slug) return;
        navigate(`/check/${selected.slug}/all`);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Selecionar Torneio</DialogTitle>

            <DialogContent dividers>
                <Stack spacing={2}>

                    {error && <Alert severity="error">{error}</Alert>}

                    <Autocomplete
                        options={options}
                        loading={loading}
                        value={selected}
                        onChange={(_, v) => setSelected(v)}
                        inputValue={inputValue}
                        onInputChange={(_, v) => setInputValue(v)}
                        getOptionLabel={(opt) => opt.name || ""}
                        renderOption={(props, opt) => (
                            <Box component="li" {...props} key={opt.slug}>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Box>
                                        <Typography variant="body2" fontWeight={600}>
                                            {opt.name?.toUpperCase()}
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Buscar torneio"
                                placeholder="Digite para buscar..."
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress size={18} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                        noOptionsText={loading ? "Carregando..." : "Nenhum torneio encontrado"}
                    />
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button
                    variant="contained"
                    onClick={handleConfirm}
                    disabled={!selected?.slug}
                >
                    Abrir
                </Button>
            </DialogActions>
        </Dialog>
    );
}
